'use client'

import { createPortal } from 'react-dom'

import { useBreakpoint } from '@common/hooks/useBreakpoints'

import {
  isPortalOnboardingVisiblePhase,
  PORTAL_ONBOARDING_PHASE,
} from '@apps/portal-onboarding/portal-onboarding.const'
import { PORTAL_ONBOARDING_TEST_IDS } from '@apps/portal-onboarding/portal-onboarding-test-ids.const'
import { usePortalOnboardingStore } from '@apps/portal-onboarding/stores/portal-onboarding.store'

import { PortalOnboardingStepView, PortalOnboardingWelcome } from './components'
import { usePortalOnboardingLifecycle } from './hooks'

import styles from './PortalTutorial.module.scss'

type PortalOnboardingProps = {
  autoStart?: boolean
}

export function PortalOnboarding({ autoStart = false }: PortalOnboardingProps) {
  const { isDesktop } = useBreakpoint()
  const phase = usePortalOnboardingStore((state) => state.phase)

  usePortalOnboardingLifecycle(autoStart, isDesktop)

  const isVisible = isPortalOnboardingVisiblePhase(phase)

  if (!isDesktop || !isVisible || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <div className={styles.root} role="presentation" data-testid={PORTAL_ONBOARDING_TEST_IDS.root}>
      {phase === PORTAL_ONBOARDING_PHASE.welcome ? <PortalOnboardingWelcome /> : <PortalOnboardingStepView />}
    </div>,
    document.body
  )
}
